import Store from 'lightningjs-redux';
import { getCurrentVideoItem } from '../../../../logic/player/video.selectors';

const mapControllers = instance => [
  {
    shouldBeInvokedOnConnect: true,
    selector: getCurrentVideoItem,
    callback: value => {
      instance.data = value;
    },
  },
];

export default Store.control(mapControllers);
